<template>
  <div class="occupationDetails" :class="{'occupationDetailsPC':$store.state.innerWidth>768}">
    <div class="occupationDetails-contain"  >
      <div class="assistant occu-assistant" :class="{'padding-30':swiperPedding}" ref="assistant">
        <div class="occupationDetails-contain-placeImg">
          <div class="occ-deco-17">
            <img class="noSelect" src="../images/deco-17.png" alt />
          </div>
          <div class="occ-Vector">
            <img class="noSelect" src="../images/deco-21.png" alt />
          </div>
          <div class="occ-deco-08">
            <img class="noSelect" src="../images/deco-08.png" alt />
          </div>
          <div class="occ-deco-18">
            <img class="noSelect" src="../images/deco-18.png" alt />
          </div>
          <div class="occ-deco-25">
            <img class="noSelect" src="../images/deco-25.png" alt />
          </div>
          <div class="occ-deco-14">
            <img class="noSelect" src="../images/deco-14.png" alt />
          </div>
        </div>
        <div class="occupation-top content-1320px col-xs-12 padLeft-0">
          <Breadcrumbs ></Breadcrumbs>
          <div class="a-content  row Occu-left col-sm-12 col-md-5" style="z-index:1">
            <h2 class="Bold fontAudit">{{$store.getters.getContent(occupationDetail.title)}}</h2>
            <div class="Regular occInner-top-text">
              <div class="item-table pad-5">
                <div class="tdcell">
                  <p >{{$store.getters.getContent(occupationDetail.description)}}</p>
                </div>
              </div>
              <div class="item-table pad-5 fontAudit-bottom">
                <div class="tdcell">
                  <p style="opacity: 0.5">{{$t('message.Related Job functions')}}</p>
               
                  <p
                    v-for="(jobFunction,index) in occupationDetail.jobFunction"
                    :key="index"
                  >{{$store.getters.getContent(jobFunction.title)}}</p>
                </div>
              </div>
            </div>
          </div>
          <div class="Occu-right col-xs-12 col-sm-12 col-md-6">
            <div class="img OccuImg" ref="OccuImg">
              <img v-bind:src="occupationDetail.imageCode" v-bind:alt="$store.getters.getContent(occupationDetail.title)"/>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="courses-content"  :class="{'padding-30':swiperPedding}">
      <div class="coursesPC content-1320px">
        <div class="row">
          <div class="col-xs-12 col-sm-12 col-md-12 btnList">
            <div class="onThisPage SemiBold">{{$t("message.on this page")}}</div>
            <button
              class="btnO btnOJia btnMove SemiBold "
              v-on:click="scrollTo(menu.key,$store.getters.getContent(menu.title))"
              v-for="(menu,index) in occupationDetail.menu"
              v-if="(courses.qrCourse.length>0||courses.edxCourse.length>0)&&menu.key=='Related Courses'||jobFunctions.length>0&&menu.key=='Related Vacancies'||(menu.key!='Related Vacancies'&&menu.key!='Related Courses')"
            >
              <a href="javascript:;" style="color: inherit">{{$store.getters.getContent(menu.title)}}</a>
            </button>
          </div>
          <div class="col-xs-12 col-sm-12 col-md-12 Occupation-ListInfo Occupation-ListInfoJia pad-0">
            <div class="experience col-xs-12 col-sm-6 col-md-6 claimJia" v-if="checkMenu('Experience')" id="Experience">
              <div class="containCheck">
                <div class="ment-information ">
                  <h2 class="Bold HJia ment-informationH">{{$t('message.Experience')}}</h2>
                  <p class="ment-informationP" v-html="$store.getters.getContent(occupationDetail.experience)"></p>
                  <!-- <p>experience is required</p> -->
                </div>
                <div class="vertical-middle ">
                  <img class="noSelect" v-bind:src="experienceImg" />
                </div>
              </div>
            </div>
            <div class="requirement col-xs-12 col-sm-6 col-md-6 claimJia" v-if="checkMenu('Requirement')" id="Requirement">
              <div class="containCheck">
                <div class="ment-information">
                  <h2 class="Bold HJia ment-informationH">{{$t('message.Requirement')}}</h2> 
                  <!-- <p class="dot-p ment-informationP" v-for="requirement in occupationDetail.requirement">{{$store.getters.getContent(requirement.description)}}</p> -->
                  <p class="dot-p ment-informationP" v-for="requirement in occupationDetail.requirement" v-html="$store.getters.getContent(requirement.description)"></p>
                </div>
                <div class="vertical-middle">
                  <img class="noSelect" v-bind:src="requirementImg" />
                </div>
              </div>
            </div>
            <div
              class="educationLevel col-xs-12 col-sm-6 col-md-6 claimJia"
              v-if="checkMenu('Education Level')"
              id="Education Level"
            >
              <div class="containCheck">
                <div class="ment-information">
                  <h2 class="Bold  HJia ment-informationH">{{$t('message.EducationLevel')}}</h2>
                  <p class="ment-informationP" v-html="$store.getters.getContent(occupationDetail.educationLevel)"></p>
                </div>
                <div class="vertical-middle ">
                  <img class="noSelect" v-bind:src="educationLevelImg" />
                </div>
              </div>
            </div>
          </div>
        </div>
        <div v-if="checkMenu('Skills')" id="Skills">
          <div  class="skills skillsJia " v-if="showShillsLg">
            <div class="pad-15 skills-information row" >
            <h2 class="col-xs-12 col-sm-12 col-md-12 padLeft-0 HJia occupation-skills Bold">{{$t('message.Skills')}}<i class="icon-i pointer i font-16 iconH2" @click="getInformation('Skills')"></i></h2>
            <div class="buttonList skills-btn col-xs-12 col-sm-12 col-md-12 pad-0 ">
              <!-- {{skillsType==1?'active':''}} -->
              <button
                class="greenBtn btnExpand  greenBtnLeft SemiBold"
                :class="skillsType==1?'active':''"
                v-on:click="clickSkills(1,'Common Skills')"
                v-if="commonSkillsState"
              >
                <a href="javascript:;" style="color: inherit">{{$t('message.Common Skills')}}</a>
              </button>
              <button
                class="greenBtn btnExpand SemiBold"
                :class="skillsType==2?'active':''"
                   v-if="growingSkillsState"
                v-on:click="clickSkills(2,'Growing skills')"
              >
                <a href="javascript:;" style="color: inherit">{{$t('message.Growing Skills')}}</a>
              </button>
            </div>
            <div class="col-xs-12 col-sm-12 col-md-12 pad-0">
              <div class="col-xs-12 col-sm-6 col-md-6 pad-0">
                <p
                  class="skills-list skills-listJia"
                  v-for="(skill,index) in commonSkills"
                  v-if="skill.type==skillsType && index <= 4"
                  :key="index"
                >
                  <span class="skills-span item-table" v-if="index<10" v-on:click="goToCourses(skill.name)">
                    <span class="listColor tdcell SemiBold">{{index + 1}}</span>
                    <span class="listText tdcell" v-if="$store.getters.getContent(skill.name) != '' ">
                      <span class="listText-iner">
                        <a href="javascript:;" style="color: inherit">{{$store.getters.getContent(skill.name)}}</a>
                      </span>
                    </span>
                    <span class="listText tdcell" v-if="$store.getters.getContent(skill.name) == '' ">
                      <span class="listText-iner">
                        <a href="javascript:;" style="color: inherit">{{skill.name[0].content}}</a>
                      </span>
                    </span>
                  </span>
                </p>
                <p
                  class="col-xs-12 col-sm-10 col-md-10 skills-list skills-listJia"
                  v-for="(skill,index) in growingSkills"
                  v-if="skill.type==skillsType &&10>index&&index<5 "
                  :key="index"
                >
                  <span
                    class="skills-span item-table"
                    v-if="index<10"
                    v-on:click="goToCourses(skill.name)"
                  >
                    <span class="listColor tdcell SemiBold">{{index + 1}}</span>
                    <span class="listText tdcell" v-if="$store.getters.getContent(skill.name) != '' ">
                      <span class="listText-iner">
                        <a href="javascript:;" style="color: inherit">{{$store.getters.getContent(skill.name)}}</a>
                        </span>
                      </span>
                    <span class="listText tdcell" v-if="$store.getters.getContent(skill.name) == '' ">
                      <span class="listText-iner">
                        <a href="javascript:;" style="color: inherit">{{skill.name[0].content}}</a>
                        </span>
                      </span>
                  </span>
                </p>
              </div>
              <!-- 相隔 -->
              <div class="col-xs-12 col-sm-6 col-md-6 pad-0">
                <p
                  class="skills-list skills-listJia "
                  v-for="(skill,index) in commonSkills"
                  v-if="skill.type==skillsType&&index>=5 && showHideSkills&&index<10"
                  :key="index"             
                >
                 <span
                    class="skills-span item-table"
                    v-if="index<10" 
                    v-on:click="goToCourses(skill.name)"
                  >
                    <span class="listColor tdcell SemiBold">{{index + 1}}</span>
                    <span class="listText tdcell" v-if="$store.getters.getContent(skill.name) != '' ">
                      <span class="listText-iner">
                        <a href="javascript:;" style="color: inherit">{{$store.getters.getContent(skill.name)}}</a>
                      </span>
                    </span>
                    <span class="listText tdcell" v-if="$store.getters.getContent(skill.name) == '' ">
                      <span class="listText-iner">
                        <a href="javascript:;" style="color: inherit">{{skill.name[0].content}}</a>
                      </span>
                    </span>
                  </span>
                </p>
                  <p
                  class="col-xs-12 col-sm-10 col-md-10 skills-list skills-listJia"
                  v-for="(skill,index) in growingSkills"
                  v-if="skill.type==skillsType &&10>index&&index>=5 && showHideSkills"
                  :key="index"              
                >
                  <span
                    class="skills-span item-table"
                    v-if="index<10"
                    v-on:click="goToCourses(skill.name)"
                  >
                    <span class="listColor tdcell SemiBold">{{index + 1}}</span>
                     <span class="listText tdcell" v-if="$store.getters.getContent(skill.name) != '' "><span class="listText-iner">{{$store.getters.getContent(skill.name)}}</span></span>
                    <span class="listText tdcell" v-if="$store.getters.getContent(skill.name) == '' "><span class="listText-iner">{{skill.name[0].content}}</span></span>
                  </span>
                </p>
              </div>
            </div>
            <!-- <div class="border"></div> -->
            <div class="more col-xs-12 col-sm-12 col-md-12 padLeft-0 padRight-0" v-if="growingSkills.length>5||growingSkills.length>5">
                <div class="moreBtn moreBtnJia" v-if="showMoreStates" @click="showMore()">
                  <span>{{$t('message.Show more')}}</span>
                  <span class="pad-lr-10 pad-lr-10Jia">
                    <i class="icon-arrow-down arrow-down-position "></i>
                  </span>
                </div>
               <div class="moreBtn moreBtnJia" v-if="!showMoreStates" @click="hideMore()">
                <span>{{$t('message.Show less')}}</span>
                <span class="pad-lr-10 pad-lr-10Jia">
                  <i class="icon-arrow-down  arrow-down-position arrow-down-rotate"></i>
                </span>
              </div>
            </div>
            <div class="skillTip Medium">{{$t('message.skillTips')}}</div>
          </div>
          </div>
        </div>
        <div
          class="statistics col-xs-12 col-sm-10 col-md-10 statisticsJia"
          v-if="checkMenu('Outlook')"
          id="Outlook"
        >
          <h2 class="Bold outlook-textJia">{{$t('message.outLook')}}</h2>
          <div class="pad-15 fen padLeft-0 padRight-0">
            <div class="statistics-imgUp">
              <!-- <h2>Education Level</h2> -->
              <div class="statisticsPlaceImg">
                <img
                  class="arrowImg noSelect"
                  :class="occupationDetail.manpowerRequirementOutlook"
                  :src="arrowImg"
                  alt
                />
                <img class="statisticsImg noSelect" v-bind:src="statisticsImg" />
              </div>
                 <div class="low-high Medium">
                <div class="Low">
                  {{$t('message.Low')}}
                </div>
                <div class="High">
                   {{$t('message.High')}}
                </div>
              </div>
                <div class="pie-chart">
                <div class="outlook-info Medium">
                    {{$t('message.Manpoweroutlook')}}
                </div>
                <i class="icon-i pointer i font-16 outlook-i " @click="getInformation('Manpoweroutlook')"></i>
              </div>
           
            </div>
            <div class="col-md-offset-1">
              <div class="statisticsPlaceImg">
                <img
                  class="arrowImg noSelect"
                  :class="occupationDetail.automationPotential"
                  :src="arrowImg"
                  alt
                />

                <img class="statisticsImg noSelect" v-bind:src="manpower" />
              </div>
              <div class="low-high Medium">
                <div class="Low">
                  {{$t('message.Low')}}
                </div>
                <div class="High">
                 {{$t('message.High')}}
                </div>
              </div>
              <div class="pie-chart">
                <div class="outlook-info Medium">
                    {{$t('message.Automationpotential')}}
                </div>
                <i class="icon-i pointer i font-16 outlook-i "  @click="getInformation('Automationpotential')"></i>
              </div>
            </div>
          </div>
        </div>

        <div class="careerPath" style="display: inline-block;width: 100%;" v-if="checkMenu('Career Path')" id="Career Path">
          <div class="pad-15 row" v-if="careerPath !='' || ( careerPathLeftStates==false && careerPathRightStates==false)">
            <h2 class="col-xs-12 col-sm-10 col-md-10 Bold align-icon career-pathJia  careerH" style="padding-left:0;">{{$t('message.CareerPath')}}</h2> 
            <!-- {{occupationDetail.careerPath}} -->
            <!-- pathType -->
            <div class="buttonList col-xs-12 col-sm-10 col-md-10 pad-0 buttonListJia career-btn" >        
              <button
                class="greenBtn btnExpand SemiBold"
                v-if="careerPathRightStates"
                :class="pathType==1?'active':''"
                v-on:click="clickCareerPath(1,'Private Sector')"   
              >
                <a href="javascript:;" style="color: inherit">{{$t('message.Private Sector')}}</a>
              </button>
                <button
                class="greenBtn btnExpand  greenBtnLeft SemiBold"
                v-if="careerPathLeftStates"
                :class="pathType==2?'active':''"
                v-on:click="clickCareerPath(2,'Government Sector')"
              >
                <a href="javascript:;" style="color: inherit">{{$t('message.Government Sector')}}</a>
              </button>
            </div>
            <div class="col-xs-12 col-sm-12 col-md-12 pad-0">
              <!-- <h2>Education Level</h2> -->
              <SwiperPeople ref="SwiperPeople" @Obtain="ObtainSwiperWidth" v-if="showCareerPath" v-bind:careerPath="careerPath"  v-bind:pathType="pathType"></SwiperPeople>
              <SwiperPeopleThree ref="SwiperPeopleThree" class="swiper-people-three"  v-if="showCareerPath" v-bind:careerPathThree="careerPathThree" v-bind:pathType="pathType"></SwiperPeopleThree>
              <div class="swiper-slide-to Regular" >
                <div class="swiper-slideInner" v-if="swiperAllWidth>this.$store.state.innerWidth">
                   <div class="slide-to-view-more">{{$t('message.Slide to view more')}}</div> 
                <div class="show-more-iconInner"> 
                  <i class="icon-arrow-down show-more-icon show-more-iconOne Bold"></i> 
                  <i class="icon-arrow-down show-more-icon Bold"></i>
                </div>
                </div>
              </div>
               <div class="careerTip Medium" v-if="pathType==2">
                  <div v-if="this.$store.state.language =='en_US' ">
                    Please refer to the <a class="careerTip-link" href="https://www.csb.gov.hk/english/admin/pay/952.html">website of the Civil Services Bureau</a> for information on Civil Service Pay Scales. 
                  </div>
                  <div v-if="this.$store.state.language =='zh_HK' ">
                    有關公務員薪級表資料，請參閱 <a class="careerTip-link" href="https://www.csb.gov.hk/tc_chi/admin/pay/952.html">公務員事務局網頁</a>
                  </div>
                  <div v-if="this.$store.state.language =='zh_CN' ">
                    有关公务员薪级表资料，请参阅 <a class="careerTip-link" href="https://sc.csb.gov.hk/gate/gb/www.csb.gov.hk/tc_chi/admin/pay/952.html">公务员事务局网页</a>
                  </div>
              </div>
            </div>
          
          </div>
        </div>
        
        <div  class="col-xs-12 col-sm-10 col-md-10 References-i References-iJia">
          <div class=" align-icon">
            <h2 class="toKnow align-icon Bold">
              {{$t('message.Relevant links')}}
              <span class="span-i" ></span>
              <a href="javascript:;" style="color: inherit" v-on:click="knowMore()">
                <i class="icon-arrow-right toKnow-i pointer"></i>
              </a>
            </h2>
          </div>
        </div>
        
        <div class="advertisingDate col-xs-12 padLeft-0">
          <div class="pad-15 row">
            <ShareBar ref="sharebar" class="col-xs-12 col-sm-10 col-md-10 padLeft-0"></ShareBar>
          </div>
        </div>
      </div>
    </div>
    
    <div class="adContent">
      <div class="Related-placeImg">
        <div class="occ-BG-deco">
          <img class="noSelect" src="../images/BG deco.png" alt />
        </div>
        <div class="occ-deco-11">
          <img class="noSelect" src="../images/deco-11.png" alt />
        </div>
      </div>
      <div class="similar similarJia courses-content"  v-if="jobFunctions.length>0"  id="Related Vacancies" style="background-color: rgba(39, 208, 196, 0.05) !important;">
        <div class="row content-1320px coursesPC" style="overflow:hidden">
          <div class="mainColor box-img-bg SemiBold box-img-bgJia box-img-bgOp "  :class="{'padding-30':swiperPedding}">
            <h2 class="RelatedJia HJia ">
              {{$t('message.RelatedJobOpportunities')}}
              <img  class="noSelect" src="../images/Vector Smart Object20.png" />
            </h2>
          </div>
          <SwiperJob ref="SwiperJob" :job-list="jobFunctions" :occupationIds="occupationDetail.id" v-if="jobFunctions.length>0" page="OccupationDetails"></SwiperJob>
          <div class="center">
            <div class="btn btn-primary op-ro-Btn btnJia" v-if="totalRows>5" @click="viewAllJobEvent" role="button" :aria-label="$t('message.View all opportunities')">
              <a href="javascript:;" style="color: inherit">{{$t('message.View all opportunities')}} ( {{jobNum}} )</a>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="adContent">      
      <div class="similar similarJia courses-content" v-if="courses.qrCourse.length>0||courses.edxCourse.length>0" id="Related Courses" style="background-color: rgb(255,255,255) !important;">
        <div class="row content-1320px coursesPC">
          <div class="mainColor box-img-bg SemiBold box-img-bgJia box-img-bgCo"  :class="{'padding-30':swiperPedding}">
            <h2 class="RelatedJia SemiBold">
              {{$t('message.RelatedCourses')}}
              <img
                class="RelatedJia-deco-16 noSelect"
                src="../images/deco-16.png"
              />
            </h2>
          </div>
          <div class="buttonList col-xs-12 col-sm-12 col-md-12 buttonList-CoursesJia item-table" :class="{'padding-40':swiperPedding}">
            <!-- {{courseType==1?'active':''}} -->
            <button
              class="greenBtn btnExpand tdcell  greenBtnLeft SemiBold" 
              :class="courseType==1?'active':''"
              v-on:click="clickCourses(1,'Common Skills')"
              v-if="courses.qrCourse.length>0"
            >
              <a href="javascript:;" style="color: inherit">{{$t('message.QR Courses')}}</a>
            </button>
            <button
              class="greenBtn btnExpand tdcell SemiBold "
              :class="courseType==2?'active':''"
              v-on:click="clickCourses(2,'Growing skills')"
              v-if="courses.edxCourse.length>0"
            >
              <a href="javascript:;" style="color: inherit">{{$t('message.MOOC Courses')}}</a>
            </button>

          </div>
          <SwiperQRcourses :course-list="courses.qrCourse" v-if="courseType==1&&courses.qrCourse.length>0"></SwiperQRcourses>
          <SwiperMOOCcourses :course-list="courses.edxCourse" v-if="courseType==2&&courses.edxCourse.length>0"></SwiperMOOCcourses>
          <div class="center op-rc-BtnInner">
            <div class="btn btn-primary op-rc-Btn btnJia" @click="viewAllCoursesEvent()" v-if="courseType==1&&courses.qrCourse.length>5" role="button" :aria-label="$t('message.View all QR Courses')">
              <a href="javascript:;" style="color: inherit">{{$t('message.View all QR Courses')}} ( {{courseNum}} )</a>
            </div>
            <div class="btn btn-primary op-rc-Btn btnJia" @click="viewAllCoursesEvent()" v-if="courseType==2&&courses.edxCourse.length>5" role="button" :aria-label="$t('message.View all MOOC Courses')">
              <a href="javascript:;" style="color: inherit">{{$t('message.View all MOOC Courses')}} ( {{courseNum}} )</a>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="occ-discover">
      <div class="courses-placeImg">
        <div class="occ-deco-12">
          <img class="noSelect" src="../images/deco-12.png" />
        </div>
      </div>
      <div class="occ-discover-text SemiBold">
        <span>{{$t('message.Discover more career resources')}}</span>
      </div>
      <div class="center Discover-btn" @click="goRsources">
        <div class="btn btn-primary" role="button" :aria-label="$t('message.FInd out more')">
          <a href="javascript:;" style="color: inherit">{{$t('message.FInd out more')}}</a>
        </div>
      </div>
    </div>
  </div>
  
</template>
<script>
import SwiperQRcourses from '@/components/SwiperQRcourses.vue'
import SwiperMOOCcourses from '@/components/SwiperMOOCcourses.vue'
import Breadcrumbs from "@/components/Breadcrumbs";
import SwiperJob from "@/components/SwiperJob.vue";
import SwiperPeople from "@/components/SwiperPeople.vue";
import SwiperPeopleThree from "@/components/SwiperPeopleThree.vue";
import ShareBar from "@/components/ShareBar.vue";
import { EventBus } from "@/javascripts/eventBus.js";

export default {
  name:"occupationDetails",
  data() {
    return {
      backgroundImg: "",
      requirementImg: "",
      experienceImg: "",
      educationLevelImg: "",

      statisticsImg: "",
      indicatorImg: "",
      occupationDetail: {},
      arrowImg: "",
      skillsType: 1,
      courseType:1,
      pathType: 0,
      occupationId: 0,
      careerPath: "",
      careerPathLeft:[],
      careerPathRight:[],
      careerPathThree:[],
      careerPathLeftStates:false,
      careerPathRightStates:false,
      langCodeContent: false,
      commonSkills: [],
      growingSkills: [],
      shillsListEn_US:'en_US',
      shillsListZh_CN:'zh_CN',
      shilllListZh_HK:'zh_HK',
      shillsStatesEn_US:false,
      shillsStatesZh_CN:false,
      shillsStatesZh_HK:false,
      showShillsLg:false,
      commonSkillsState:false,
      growingSkillsState:false,
      lg : this.$i18n.locale,
      showMoreStates:true,
      showHideSkills:true,
      screenWidth: document.body.clientWidth, // 屏幕宽度
      courses:{
        qrCourse:[],
        edxCourse:[]
      },
      totalRows:0,
      jobFunctions:[],
      swiperPedding:false,
      swiperAllWidth:0,
      showJobSwiper:true,
      showCareerPath:false,
      courseNum: 0,
      jobNum: 0,
    }
  },   
    
  computed:{
    count(){
      return this.$store.state.language;
    },
    innerwidth(){
      return this.$store.state.innerWidth;
    },
    _language(){
      return this.$store.state.language
    }
  },
  props: ["logGaEvent"],
  components: {
    Breadcrumbs,
    SwiperJob,
    ShareBar,
    SwiperPeople,
    SwiperQRcourses,
    SwiperMOOCcourses,
    SwiperPeopleThree
  },
 
  methods: {
    ObtainSwiperWidth:function(width){
    
      this.swiperAllWidth = width;

    },
    goRsources:function(){
         this.$router.push({ path: "/resources" , query:{lang:this.$store.state.language}});
         window.scrollTo(0,0);
    },
    careerPathFun(){
      this.careerPathLeft = [];
      this.careerPathRight = [];
      this.careerPathThree = [];
        this.careerPath.forEach(item =>{
          if(item.pathType == 2){
            this.careerPathLeft.push(item);
          }else if(item.pathType == 1 ){
            this.careerPathRight.push(item);
          }else if(item.pathType == 3){
            this.careerPathThree.push(item);
          
          }
        })
      
        this.careerPathLeft.length ==0? this.careerPathLeftStates = false:this.careerPathLeftStates = true;
        this.careerPathRight.length ==0? this.careerPathRightStates = false:this.careerPathRightStates = true;
    },
    showMore(){
      this.showHideSkills = true;
      this.showMoreStates = false;
      // if(this.screenWidth<768){
      //   this.showHideSkills = false;
      // }else{
      //   this.showHideSkills = true;
      // }
    },
    hideMore(){
        this.showHideSkills = false;
        this.showMoreStates = true;
    },
    getLg(){
      this.showShillsLg = false;
      this.lg= this.$i18n.locale;
      if(this.lg==this.shillsListEn_US&&this.shillsStatesEn_US==true){
        this.showShillsLg = true;
      }else if(this.lg==this.shillsListZh_CN&&this.shillsStatesZh_CN==true){
          this.showShillsLg = true;
      }else if(this.lg==this.shilllListZh_HK&&this.shillsStatesZh_HK==true){
          this.showShillsLg = true;
      }
    },
    // 
    pushCourse: function() {
      var that = this;
      that.$router.push({ path: "/BrowseCourses" , query:{lang:this.$store.state.language}});
      window.scrollTo(0, 0);
    },
    forSkills: function() {
      var that = this;
      that.commonSkills = [];
      that.growingSkills = [];
      that.occupationDetail.skills.forEach(item => {
        if (item.type == 1) {
          that.commonSkills.push(item);
        } else if (item.type == 2) {
          that.growingSkills.push(item);
        }
      });
      that.commonSkills.forEach(item =>{
        if(item.name[0].content!=''){
          that.shillsStatesEn_US = true;
        }
        if(!item.name[1]){
          item.name[1] = {
            content:item.name[0].content,
            langCode:"zh_CN"
          }
        }
        if(!item.name[2]){
          item.name[2] = {
            content:item.name[0].content,
            langCode:"zh_HK"
          }
        }
        if(item.name[1].content!=''){
          that.shillsStatesZh_CN = true;
        }
        if(item.name[2].content!=''){
          that.shillsStatesZh_HK = true;
        }
      })
      that.commonSkills.forEach(item =>{
          if(item.content != ''){
            that.commonSkillsState = true;
          }
      })
      that.growingSkills.forEach(item =>{
          if(item.content != ''){
              that.growingSkillsState =true;
          }
          if(!item.name[1]){
            item.name[1] = {
              content:item.name[0].content,
              langCode:"zh_CN"
            }
          }
          if(!item.name[2]){
            item.name[2] = {
              content:item.name[0].content,
              langCode:"zh_HK"
            }
          }
      })
    
    },
    checkMenu: function(item) {
      // 
      if (!this.occupationDetail.menu) {
        return false;
      }
      return this.occupationDetail.menu.find(menu => menu.key == item);
    },

    scrollTo: function(elId, name) {
      this.logGaEvent("userClick", "menuButton", name);
      let el = document.getElementById(elId);
      el.scrollIntoView();
    },
    clickSkills: function(pathType, name) {
      this.logGaEvent("userClick", "skillsButton", name);
      this.skillsType = pathType;
      if(this.$refs.SwiperJob){
        this.$refs.SwiperJob.setWidth();
      }
      if(this.$refs.SwiperPeople){
        this.$refs.SwiperPeople.setWidth();
      }
      if(this.$refs.SwiperPeopleThree){
        this.$refs.SwiperPeopleThree.setWidth();
      }
      // this.showJobSwiper = false;
      // var that = this;
      // setTimeout(function(){
      //   that.showJobSwiper = true;
      // })
    },
    clickCourses: function(pathType, name) {
      this.logGaEvent("userClick", "skillsButton", name);
      this.courseType = pathType;
      pathType == 1 ? this.courseNum = this.courses.qrTotalRows : this.courseNum = this.courses.edxTotalRows
      if(this.$refs.SwiperJob){
        this.$refs.SwiperJob.setWidth();
      }
      if(this.$refs.SwiperPeople){
        this.$refs.SwiperPeople.setWidth();
      }
      if(this.$refs.SwiperPeopleThree){
        this.$refs.SwiperPeopleThree.setWidth();
      }
      // this.showJobSwiper = false;
      // var that = this;
      // setTimeout(function(){
      //   that.showJobSwiper = true;
      // })
    },
    clickCareerPath: function(pathType, name) {
    
      this.logGaEvent("userClick", "careerPathButton", name);

      this.pathType = pathType;
    },
    goToCourses:function(keyword){
      keyword = keyword.find(o=>o.langCode=='en_US').content
      
     
      this.$router.push({path:"/BrowseCourses/"+keyword, query:{lang:this.$store.state.language}});
      window.scrollTo(0, 0);
    },
    knowMore:function(){
      var data=this.occupationDetail.references;
      
      var text=""
      var that = this;
      data.map(function(v,i){
        // 
        text+="<div class='department departmentJia '><div class='popup-content popup-link'><p><a  class=' SemiBold listText-iner popup-a'' href='"+that.$store.getters.getContent(v.url)+"' target='_blank'>"+that.$store.getters.getContent(v.title)+"</a></p></div></div>"
      })
      EventBus.$emit('showPopup', {text:text,title:this.$i18n.t("message.To know more")})
    },
    getInformation:function(key){
      var data=this.$store.getters.getInformation(key);
      if(data[0].link){
        var link = "<a  class='info-link mainColor ' href='"+data[0].link+"' target='_blank'>"+data[0].link_text+"</a>";
      }else{
        var links = this.$store.getters.getVTClink(this.$route.params.id);
        var link = "<a  class='info-link mainColor ' href='"+links[0].link+"' target='_blank'>"+this.$i18n.t("message.link")+"</a>";
      }
      
      var text=""
      

      data[0].label.map(function(v,i){
        
        text+="<div class='department departmentJia pad-15 '><div class='popup-content '>"+v+"</div></div>"
      })
      text = text.replace('[link]', link);
      EventBus.$emit('showPopup', {text:text,title:this.$i18n.t("message."+key)})
    },
    getCoursesList:function(id){
      let that = this;
      that.api.getListByOccupation({ "occupationId": id,}, function(data) {
          that.courses = data.result;
          for(let i=0;i<that.courses.qrCourse.length;i++){
              if(that.courses.qrCourse[i].learningMode){
                  that.courses.qrCourse[i].learningMode = that.courses.qrCourse[i].learningMode.split(",")
              }
          }
          for(let i=0;i<that.courses.edxCourse.length;i++){
              if(that.courses.edxCourse[i].learningMode){
                  that.courses.edxCourse[i].learningMode = that.courses.edxCourse[i].learningMode.split(",")
              }
          }
          if(that.courses.qrCourse.length==0&&that.courses.edxCourse.length>0){
            that.courseType = 2;
          }
         
      })
      
    },
    viewAllCoursesEvent:function(){
      this.$store.state.formData.occupationId = this.occupationDetail.id;
      if(this.courseType==1){
        this.$store.state.formData.coursesType = 1;
      }else if(this.courseType ==2){
        this.$store.state.formData.coursesType = 2;
      }
      this.$router.push({ path: '/ReratedCourses' , query:{lang:this.$store.state.language}});
    },
    getRelatedJob:function(){
      var that = this;
      let data = {
          "startRow": 0,
          "maxRows": 5,
        }
      data.occupationId = that.occupationId;
      that.api.getOccupationJobList(data, function(data) {
          that.totalRows = data.totalRows;
          that.jobFunctions = [];
          for (var i = 0; i < data.result.length; i++) {
              that.jobFunctions.push(data.result[i]);
          }
      })
    },
    viewAllJobEvent:function(){
      this.$store.state.formData.occupationId = this.occupationDetail.id;
      this.$store.state.formData.relatedJobType=1;
      this.$store.state.formData.jobId = ""
      this.$router.push({ path: '/RelatedVacancies' , query:{lang:this.$store.state.language}});
    },
    checkWidth:function(){
      this.$refs.OccuImg.style.height = this.$refs.OccuImg.offsetWidth*180/240 +'px';
      if(this.$store.state.innerWidth >= 769){
        this.showHideSkills = true;
      }else{
        this.showHideSkills = false;
      }
      if(this.$store.state.innerWidth>=1345){
          this.swiperPedding = false;
      }else if(this.$store.state.innerWidth >= 1080){
          this.swiperPedding = true;
      }else if(this.$store.state.innerWidth >= 815){
          this.swiperPedding = true;
      }else{
          this.swiperPedding = false;
      }
    }
    //
  },
  beforeRouteLeave(to, from, next){ 

  
      this.fromLouterName = to.name;
      
      if(to.name=='browseOccupations'){
          to.meta.isUseCache = false;
      }else{
          to.meta.isUseCache = true;
      }
          next()
  },
  watch:{
    innerwidth (news,old) {
      this.checkWidth();
    },
    count (news, old){
      this.getLg();
    },
    _language:{
      handler: function(val, oldVal) {
        if (this.$route.path.indexOf("occupationDetails") > 0) {
          var breadcrumbs = this.$route.meta.breadcrumbs.find(
            b => b.to.indexOf("occupationDetails") > 0
          );
          if (breadcrumbs) {
            breadcrumbs.text = this.$store.getters.getContent(
              this.occupationDetail.title
            );
            breadcrumbs.to = "/occupationDetails/" + this.$route.params.id;
          }
          // this.$router.push({query: {lang: val,name:this.$store.getters.replaceEvent(this.$store.getters.getContent(
          //       this.occupationDetail.title
          //     ))}})
        }
        this.title = document.title =  this.$store.getters.getContent(
              this.occupationDetail.title
            ) + " - "+this.$i18n.t("message.Careers_title")+" - talent.gov.hk";
      },
      deep: true
    },
    totalRows (news, old) {
      this.jobNum = news
      this.occupationDetail.menu.forEach( menu => { 
        if (menu.key == "Related Vacancies") {
          for(let i = 0; i<menu.title.length; i++) {
            menu.title[i].content = `${menu.title[i].content} (${news})`
          }
        }
      })
    },
    courses (news, old) {
      this.courseNum = news.qrTotalRows
      // if( this.occupationDetail.menu ) {
      //   this.occupationDetail.menu.forEach( menu => { 
      //     if (menu.key == "Related Courses") {
      //       for(let i = 0; i<menu.title.length; i++) {
      //         menu.title[i].content = `${menu.title[i].content} (${news.totalRows})`
      //       }
      //     }
      //   })
      // }
    }
  },
  created() {
  
  },
  activated(){
  
    var that = this;
    this.showMoreStates = true;
    if(!this.$route.meta.isUseCache){
      this.$store.state.selectMenu = 2;
      
      window.scrollTo(0, 0);
    // 
      this.skillsType = 1;
      this.courseType=1;
      this.pathType = 0;
    that.occupationId = this.$route.params.id;
    this.getCoursesList(that.occupationId);
    this.getRelatedJob();
    this.showCareerPath = false;
    new Promise((resolve, reject) => {
      this.api.getOccupationDetail({ id: that.occupationId }, function(data) {
        that.occupationDetail = data.result;
        that.$refs.sharebar.resetUrl();
        that.occupationDetail.menu.forEach( menu => {
          if (menu.key == "Related Courses") {
            for(let i = 0; i<menu.title.length; i++) {
              menu.title[i].content = `${menu.title[i].content} (${that.courses.totalRows})`
            }
          }
        });

        if(that.occupationDetail.automationPotential<0.2){
          that.occupationDetail.automationPotential="rotate-1";
        }else if(that.occupationDetail.automationPotential>=0.2&&that.occupationDetail.automationPotential<0.4){
          that.occupationDetail.automationPotential="rotate-2";
        }else if(that.occupationDetail.automationPotential>=0.4&&that.occupationDetail.automationPotential<0.6){
          that.occupationDetail.automationPotential="rotate-3";
        }else if(that.occupationDetail.automationPotential>=0.6&&that.occupationDetail.automationPotential<0.8){
          that.occupationDetail.automationPotential="rotate-4";
        }else if(that.occupationDetail.automationPotential>=0.8){
          that.occupationDetail.automationPotential="rotate-5";
        }
        if(that.occupationDetail.manpowerRequirementOutlook<-0.015){
          that.occupationDetail.manpowerRequirementOutlook="rotate-1";
        }else if(that.occupationDetail.manpowerRequirementOutlook>=-0.015&&that.occupationDetail.manpowerRequirementOutlook<-0.005){
          that.occupationDetail.manpowerRequirementOutlook="rotate-2";
        }else if(that.occupationDetail.manpowerRequirementOutlook>=-0.005&&that.occupationDetail.manpowerRequirementOutlook<0.005){
          that.occupationDetail.manpowerRequirementOutlook="rotate-3";
        }else if(that.occupationDetail.manpowerRequirementOutlook>=0.005&&that.occupationDetail.manpowerRequirementOutlook<0.015){
          that.occupationDetail.manpowerRequirementOutlook="rotate-4";
        }else if(that.occupationDetail.manpowerRequirementOutlook>=0.015){
          that.occupationDetail.manpowerRequirementOutlook="rotate-5";
        } 
        if(data.result.careerPath==null){
          data.result.careerPath = [];
        }
        that.careerPath = data.result.careerPath;
        that.showCareerPath = true;
        resolve();
        if (that.$route.path.indexOf("occupationDetails") > 0) {
          var breadcrumbs = that.$route.meta.breadcrumbs.find(
            b => b.to.indexOf("occupationDetails") > 0
          );
          if (breadcrumbs) {
            breadcrumbs.text = that.$store.getters.getContent(
              that.occupationDetail.title
            );
            breadcrumbs.to = "/occupationDetails/" + that.$route.params.id;
          }
        }
        that.$store.state.mate.title = document.title =  that.$store.getters.getContent(
              that.occupationDetail.title
            ) + " - "+that.$i18n.t("message.Careers_title")+" - talent.gov.hk";
        that.$store.state.mate.description =  that.$store.getters.getContent(
              that.occupationDetail.description
            );
        that.$store.state.mate.keywords = that.$i18n.t("message.Careers_keywords");
        that.$store.state.mate.image = that.occupationDetail.imageCode;
        if(that.$store.state.mate.image.indexOf('.jpg')>0){
          that.$store.state.mate.imageType = "image/jpg"
        }else if(that.$store.state.mate.image.indexOf('.jpeg')>0){
          that.$store.state.mate.imageType = "image/jpeg"
        }
      });
    }).then(res => {
      that.careerPathFun();
      if(that.careerPathRight.length !=0){
      
        that.clickCareerPath(1,'Private Sector');
      }else if(that.careerPathLeft.length !=0){
          that.clickCareerPath(2,'Government Sector');
      }
     
      that.forSkills();
      that.getLg();
     
    });
     
    this.checkWidth();
    // this.api.getCourseList();
    this.backgroundImg = require("@/images/browse4.png");
    this.requirementImg = require("@/images/Requirement.png");
    this.experienceImg = require("@/images/Experience.png");
    this.educationLevelImg = require("@/images/Education leve.png");
    this.statisticsImg = require("@/images/auto.png");
    this.manpower = require("@/images/manpower.png");
    this.indicatorImg = require("@/images/indicator.png");
    this.arrowImg = require("@/images/indicator.png");
    // this.$refs.assistant.style.height = window.innerHeight - 85 + "px";
    }
     
  },
  mounted() {
    var that = this;
    window.scrollTo(0, 0);
    this.$store.state.selectMenu = 2;
    // 

    that.occupationId = this.$route.params.id;
    this.$store.state.mate.width = 1000;
    this.$store.state.mate.height = 800;
    this.showCareerPath = false;
    
    this.getCoursesList(that.occupationId);
    this.getRelatedJob()
    new Promise((resolve, reject) => {
      this.api.getOccupationDetail({ id: that.occupationId }, function(data) {
        that.occupationDetail = data.result;
        that.occupationDetail.menu.forEach( menu => {
          if (menu.key == "Related Courses") {
            for(let i = 0; i<menu.title.length; i++) {
              menu.title[i].content = `${menu.title[i].content} (${that.courses.totalRows})`
            }
          }
        });
        if(that.occupationDetail.automationPotential<0.2){
          that.occupationDetail.automationPotential="rotate-1";
        }else if(that.occupationDetail.automationPotential>=0.2&&that.occupationDetail.automationPotential<0.4){
          that.occupationDetail.automationPotential="rotate-2";
        }else if(that.occupationDetail.automationPotential>=0.4&&that.occupationDetail.automationPotential<0.6){
          that.occupationDetail.automationPotential="rotate-3";
        }else if(that.occupationDetail.automationPotential>=0.6&&that.occupationDetail.automationPotential<0.8){
          that.occupationDetail.automationPotential="rotate-4";
        }else if(that.occupationDetail.automationPotential>=0.8){
          that.occupationDetail.automationPotential="rotate-5";
        }
        if(that.occupationDetail.manpowerRequirementOutlook<-0.015){
          that.occupationDetail.manpowerRequirementOutlook="rotate-1";
        }else if(that.occupationDetail.manpowerRequirementOutlook>=-0.015&&that.occupationDetail.manpowerRequirementOutlook<-0.005){
          that.occupationDetail.manpowerRequirementOutlook="rotate-2";
        }else if(that.occupationDetail.manpowerRequirementOutlook>=-0.005&&that.occupationDetail.manpowerRequirementOutlook<0.005){
          that.occupationDetail.manpowerRequirementOutlook="rotate-3";
        }else if(that.occupationDetail.manpowerRequirementOutlook>=0.005&&that.occupationDetail.manpowerRequirementOutlook<0.015){
          that.occupationDetail.manpowerRequirementOutlook="rotate-4";
        }else if(that.occupationDetail.manpowerRequirementOutlook>=0.015){
          that.occupationDetail.manpowerRequirementOutlook="rotate-5";
        } 
        if(data.result.careerPath==null){
          data.result.careerPath = [];
        }
        that.careerPath = data.result.careerPath;
        that.showCareerPath = true;
        resolve();
        if (that.$route.path.indexOf("occupationDetails") > 0) {
          var breadcrumbs = that.$route.meta.breadcrumbs.find(
            b => b.to.indexOf("occupationDetails") > 0
          );
          if (breadcrumbs) {
            breadcrumbs.text = that.$store.getters.getContent(
              that.occupationDetail.title
            );
            breadcrumbs.to = "/occupationDetails/" + that.$route.params.id;
          }
        }
        that.$store.state.mate.title = document.title =  that.$store.getters.getContent(
              that.occupationDetail.title
            ) + " - "+that.$i18n.t("message.Careers_title")+" - talent.gov.hk";
        that.$store.state.mate.description =  that.$store.getters.getContent(
              that.occupationDetail.description
            );
        that.$store.state.mate.keywords = that.$i18n.t("message.Careers_keywords");
        that.$store.state.mate.image = that.occupationDetail.imageCode;
        if(that.$store.state.mate.image.indexOf('.jpg')>0){
          that.$store.state.mate.imageType = "image/jpg"
        }else if(that.$store.state.mate.image.indexOf('.jpeg')>0){
          that.$store.state.mate.imageType = "image/jpeg"
        }
      });
    }).then(res => {
      that.careerPathFun();
      if(that.careerPathRight.length !=0){
      
        that.clickCareerPath(1,'Private Sector');
      }else if(that.careerPathLeft.length !=0){
          that.clickCareerPath(2,'Government Sector');
      }
     
      that.forSkills();
      that.getLg();
     
    });
     
    this.checkWidth();
    // this.api.getCourseList();
    this.backgroundImg = require("@/images/browse4.png");
    this.requirementImg = require("@/images/Requirement.png");
    this.experienceImg = require("@/images/Experience.png");
    this.educationLevelImg = require("@/images/Education leve.png");
    this.statisticsImg = require("@/images/auto.png");
    this.manpower = require("@/images/manpower.png");
    this.indicatorImg = require("@/images/indicator.png");
    this.arrowImg = require("@/images/indicator.png");
    // this.$refs.assistant.style.height = window.innerHeight - 85 + "px";
   
   
  }
 
};
</script>

<style scoped>
.ment-informationP /deep/ p {
  padding: 0 !important;
}
</style>